import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const GlassMTiles = () => {
  return (
    <>
      <Headers/>
      <div>
        <h1>Glass Mosaic Tiles</h1>
      </div>
      <Footers/>
      <FooterCall/>
    </>
  )
}

export default GlassMTiles
